import { throwError as observableThrowError, Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ContactusDetail } from '../models/contact'
import { ContactusGateway } from './contact-gateway'

@Injectable()
export class NetworkcontactusGateway implements ContactusGateway {
    constructor(private http: HttpClient) {}

    public handleError = (error: Response) => {
        // Do messaging and error handling here
        return observableThrowError(error)
    }

    GetCotactContent(ParentName: string, SectionName: string, insCo: number, planyear: number): Observable<ContactusDetail[]> {
        let getURL = '../api/content/GetContactByPlanYear/' + ParentName + '/' + SectionName + '/' + insCo + '/' + planyear
        return this.http.get<ContactusDetail[]>(getURL)
    }
}
